import React from 'react';
import { StyledLine } from './index.styled';

export const Line = () => <StyledLine />;
